import { pickT } from "@repo/shared";
import type { ClientAccessDenial } from "@repo/shared/types";
import { T } from "./client-access-denial-text.i18n";

/** QL-380 — user-facing text for a client access denial. Never includes the client's name. */
export function clientAccessDenialText(denial: ClientAccessDenial, lang: string) {
  const t = pickT(T, lang);
  const message =
    denial.reason === "team"
      ? t.team(denial.teams.map((team) => team.name).join(", "))
      : denial.owner
        ? t.privateOwner(
            [denial.owner.name, denial.owner.email && `(${denial.owner.email})`]
              .filter(Boolean)
              .join(" "),
          )
        : t.privateNoOwner;
  return { title: t.title, message, back: t.back };
}
